import React, { Component } from 'react'
import { localize } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'
import InputField from '../../controls/InputField'
import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import Icon from '@material-ui/core/Icon'

class SearchPractitioner extends Component {
  constructor () {
    super()

    this.search = this.search.bind(this)
    this.checkEnter = this.checkEnter.bind(this)
    this.validate = this.validate.bind(this)

    this.validatePhoneValue = this.validatePhoneValue.bind(this)
    this.validatePhone = this.validatePhone.bind(this)
    this.onChangePhone = this.onChangePhone.bind(this)

    this.validatePostalCodeValue = this.validatePostalCodeValue.bind(this)
    this.validatePostalCode = this.validatePostalCode.bind(this)
    this.onChangePostalCode = this.onChangePostalCode.bind(this)

    this.postalCode = React.createRef()
    this.phone = React.createRef()

    this.state = {
      phone: '',
      postalCode: '',
      errors: {}
    }
  }
  componentWillUnmount () {
    this.setState({
      phone: '',
      postalCode: '',
      errors: {}
    })
  }

  search (e) {
    if (this.validate()) {
      e.preventDefault()
      this.props.setSearched()
      this.props.searchPractitioners({
        Category: this.props.type,
        PhoneNumber: this.state.phone,
        PostalCode: this.state.postalCode
      })
    }
  }

  checkEnter (e) {
    const code = (e.keyCode ? e.keyCode : e.which)
    if (code === 13) {
      this.search(e)
    }
  }

  validate () {
    const { phone, postalCode } = this.state
    const isPhoneValid = this.validatePhone(phone)
    const isPostalCodeValid = this.validatePostalCode(postalCode)
    return isPhoneValid && isPostalCodeValid
  }

  // Phone:

  validatePhoneValue (phone = '') {
    return phone.replace(/\D/g, '').length === 10
  }

  validatePhone (phone = '') {
    let isValid = true
    const errors = this.state.errors

    if (!this.validatePhoneValue(phone)) {
      errors.phone = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPhoneError')
      isValid = false
    } else {
      errors.phone = null
    }

    this.setState({ errors })

    return isValid
  }

  onChangePhone (e, phone = '') {
    this.setState({ phone })

    // This looks redundant but isn't. In this case we need to
    // validate only if the change has set the phone number
    // to a valid value. This clears the error message when
    // the user has corrected an invalid input.
    if (this.validatePhoneValue(phone)) {
      this.validatePhone(phone)
    }
  }

  // Postal Code:

  validatePostalCodeValue (postalCode = '') {
    return postalCode.replace(/_/g, '').length === 7
  }

  validatePostalCode (postalCode = '') {
    let isValid = true
    const errors = this.state.errors

    if (!this.validatePostalCodeValue(postalCode)) {
      errors.postalCode = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPostalCodeError')
      isValid = false
    } else {
      errors.postalCode = null
    }

    this.setState({ errors })

    return isValid
  }

  onChangePostalCode (e, postalCode = '') {
    this.setState({ postalCode })

    // This looks redundant but isn't. In this case we need to
    // validate only if the change has set the postal code
    // to a valid value. This clears the error message when
    // the user has corrected an invalid input.
    if (this.validatePostalCodeValue(postalCode)) {
      this.validatePostalCode(postalCode)
    }
  }

  render () {
    return (
      <form onSubmit={this.search}>
        <Paper style={{ paddingTop: 15 }}>
          <Row center='xs' middle='xs'>

            <Col xs={12} sm={12} md={5} lg={5} style={{ padding: '0px 5px' }}>
              <InputField
                type='tel'
                mask={['(', /[1-9]/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                fullWidth
                floatingLabelText={localize('pages.SubmitAClaim.PhoneNumber')}
                style={{ marginRight: 10, marginTop: '-14px' }}
                onChange={this.onChangePhone}
                value={this.state.phone}
                onKeyPress={this.checkEnter}
                errorText={this.state.errors.phone}
                errorStyle={{ position: 'absolute', top: 68 }}
                onBlur={() => this.validatePhone(this.state.phone)}
              />
            </Col>
            <Col xs={12} sm={12} md={5} lg={5} style={{ padding: '0px 5px' }}>
              <InputField
                fullWidth
                floatingLabelText={localize('pages.SubmitAClaim.PostalCode')}
                style={{ marginRight: 10 }}
                onChange={this.onChangePostalCode}
                mask={[/[A-Z]/i, /\d/, /[A-Z]/i, ' ', /\d/, /[A-Z]/i, /\d/]}
                value={this.state.postalCode}
                onKeyPress={this.checkEnter}
                errorText={this.state.errors.postalCode}
                errorStyle={{ position: 'absolute', top: 68 }}
                onBlur={() => this.validatePostalCode(this.state.postalCode)}
              />
            </Col>
            <IconButton onClick={this.search}>
              <Icon>search</Icon>
            </IconButton>
          </Row>
        </Paper>
      </form>
    )
  }
}

export default SearchPractitioner



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/searchPractitioner.js